var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { setComponentTemplate } from '@ember/component';
import { inject as service } from '@ember/service';
import { hbs } from 'ember-cli-htmlbars';
import { emit, select } from '@banking/ui/services/card-management/reset-pin-modal';
import { setPinAction, toggleModalAction, userChangeConfirmPinAction, userChangePinAction, ValueError, Error as SetPinError } from '@banking/ui/workflows/card-settings/set-pin';
let ConnectedResetPin = (_dec = select(state => state.isOpen), _dec2 = select(state => state.confirmPin), _dec3 = select(state => state.confirmPinError?.[0]), _dec4 = select(state => state.pinError?.[0]), _dec5 = select(state => state.error?.[0]), _dec6 = select(state => state.pin), _dec7 = select(state => state.loading), _class = class ConnectedResetPin extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "active", _descriptor2, this);
    _initializerDefineProperty(this, "confirmPinValue", _descriptor3, this);
    _initializerDefineProperty(this, "confirmPinError", _descriptor4, this);
    _initializerDefineProperty(this, "createPinError", _descriptor5, this);
    _initializerDefineProperty(this, "createPinScreenError", _descriptor6, this);
    _initializerDefineProperty(this, "createPinValue", _descriptor7, this);
    _initializerDefineProperty(this, "loading", _descriptor8, this);
  }
  get screenErrorMessage() {
    switch (this.createPinScreenError) {
      case SetPinError.GenericError:
        return this.intl.t('banking.checking.cardSettings.pin.error.generic');
      case SetPinError.InvalidPinMatch:
        return this.intl.t('banking.checking.cardSettings.pin.error.notMatch');
      case SetPinError.WeakPin:
        return this.intl.t('banking.checking.cardSettings.pin.error.weak');
      case undefined:
        return undefined;
      default:
        throw new Error('Unsupported error type');
    }
  }
  get confirmPinErrorMessage() {
    switch (this.confirmPinError) {
      case ValueError.InvalidLength:
        return this.intl.t('banking.checking.cardSettings.pin.error.validInput');
      case undefined:
        return undefined;
      default:
        throw new Error('Unsupported error type');
    }
  }
  get createPinErrorMessage() {
    switch (this.createPinError) {
      case ValueError.InvalidLength:
        return this.intl.t('banking.checking.cardSettings.pin.error.validInput');
      case undefined:
        return undefined;
      default:
        throw new Error('Unsupported error type');
    }
  }
  closeModal() {
    return toggleModalAction(false);
  }
  onConfirmPinChange(pin) {
    return userChangeConfirmPinAction(pin);
  }
  onCreatePinChange(pin) {
    return userChangePinAction(pin);
  }
  onSavePin() {
    return setPinAction();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "confirmPinValue", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "confirmPinError", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "createPinError", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "createPinScreenError", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "createPinValue", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "loading", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "closeModal", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmPinChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmPinChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreatePinChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onCreatePinChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSavePin", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSavePin"), _class.prototype), _class);
export { ConnectedResetPin as default };
setComponentTemplate(hbs`
   <Banking::Checking::CardSettings::ResetPin
     @active={{this.active}}
     @closeModal={{this.closeModal}}
     @createPinValue={{this.createPinValue}}
     @confirmPinValue={{this.confirmPinValue}}
     @createPinErrorMessage={{this.createPinErrorMessage}}
     @confirmPinErrorMessage={{this.confirmPinErrorMessage}}
     @createPinScreenErrorMessage={{this.screenErrorMessage}}
     @isLoading={{this.loading}}
     @onCreatePinChange={{this.onCreatePinChange}}
     @onConfirmPinChange={{this.onConfirmPinChange}}
     @onSavePin={{this.onSavePin}}
   />
  `, ConnectedResetPin);